<template>
    <div class="timelines">
     <div>
        <item-input ref="scan_device" type="scan" v-model="scan_val" placeholder="请扫设备条码"
            @input="scanDevice()"></item-input>
    </div>
    <div>
        <mt-index-list>
            <div class="content">
                <div class="surgeryInfo" style="margin: 10px 0px;" v-for="rb in usedDevice"
                    :key="rb.id">
                    <div class="header flex-row justify-between" style="font-size: 0.4rem;">
                        <span><b>{{rb.device.type_name}}-{{ rb.device.name }}</b></span>
                        <span class="padding2 align-right">使用总时长{{ rb.use_time_hour }}时/{{
                            rb.use_time_minutes
                            }}分</span>
                        <span class="cus-button is-circle el-icon-delete fg-danger"
                            style="float: right;margin-right: 10px;" title="移除设备"
                            @click="remove(rb)"></span>
                    </div>
                    <div class="flex-row justify-between"
                        style="height: 0.8rem;line-height: 0.8rem;font-size: 0.4rem;"
                        v-for="detail in rb.use_device_details" :key="detail.id">
                        <span
                            class="patientTitle"></span>
                        <div>
                            <span class="cus-button is-circle el-icon-delete fg-danger font-size18"
                                style="float: right;" title="移除设备"
                                @click="deleteUserDevice(detail.id)"></span>
                            <span class="cus-button is-circle el-icon-edit fg-danger font-size18"
                                style="float: right;" title="编辑"
                                @click="editDeviceDetail(detail,rb.device)"></span>
                        </div>
                    </div>
                </div>
            </div>
        </mt-index-list>
    </div>
    <el-dialog :close-on-click-modal="false" width="80%" class="table-h300 deviceDilog" :destroy-on-close="true"
        :visible.sync="activeDevicePopupVisible" title="绑定设备">
        <div class="text-wrapper_base text-wrapper_2 flex-row justify-between">
            <span class="text_base text_base_label">设备名称</span>
            <span class="text_base text_base_value">{{
                activeDevice &&activeDevice.name }}</span>
        </div>
        <div class="text-wrapper_base flex-row justify-between">
            <span class="text_base text_base_label">编号</span> <span class="text_base text_base_value">{{
                activeDevice &&
                activeDevice.model
                }}</span>
        </div>
        <div class="text-wrapper_base flex-row justify-between">
            <span class="text_base text_base_label">类型</span>
            <span class="text_base text_base_value">{{ activeDevice && activeDevice.type_name }}</span>
        </div>
        <div v-if="activeDevice && (activeDevice.showType=='bind' || activeDevice.showType=='edit')"
            class="margin10 margin-none-h align-left">
            <span class="align-left line-height30">绑定时间：</span>
            <item-input type="datetime" v-if="activeDevice" v-model="activeDevice.begin_time"
                @input="changeUseTime(activeDevice.begin_time, activeDevice.end_time)"></item-input>
        </div>
        <div v-if="activeDevice && (activeDevice.showType=='unbind' || activeDevice.showType=='edit')"
            class="margin10 margin-none-h align-left">
            <span class="align-left line-height30">解绑时间：</span>
            <item-input type="datetime" v-if="activeDevice" v-model="activeDevice.end_time"
                @input="changeUseTime(activeDevice.begin_time, activeDevice.end_time)"></item-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="activeDevicePopupVisible = false">取 消</el-button>
            <el-button type="primary" @click="useDevice(activeDevice)">确 定</el-button>
        </span>
    </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { MessageBox, Navbar, TabItem, TabContainer, TabContainerItem, Popup, IndexList, IndexSection, Cell } from 'mint-ui'
export default {
    name: `DeviceBind`,
    props: {
        surgeryId: Number,
        surgeryInfo: Object,
        visible: { type: Boolean }
    },
    components: {
        'mt-navbar': Navbar,
        'mt-tab-item': TabItem,
        'mt-tab-container': TabContainer,
        'mt-tab-container-item': TabContainerItem,
        'mt-popup': Popup,
        'mt-index-list': IndexList,
        'mt-index-section': IndexSection,
        'mt-cell': Cell
    },
    data() {
        return {
            usedDevice: [],
            allDevice: [],
            scan_val: ``,
            activeDevice: {},
            activeDevicePopupVisible: false
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `sysuser/workers`, `ward_auth`, `active_hospital_ward`])
    },
    created() {
        if (this.surgeryId) {
            this.loadDevices()
        }
    },
    mounted() {},
    methods: {
        loadDevices() {
            if (!this.surgeryId) { return }
            let req1 = this.myaxios.get(`/api/AcisSystem/Device/Get`)
            let req2 = this.myaxios.get(`/api/Nursing/UseDevice/Get?surgeryId=${this.surgeryId}`)
            this.myaxios.all(req1, req2).then(([allDevice, used]) => {
                this.allDevice = allDevice
                console.log(used)
                this.usedDevice = used
            })
        },
        scanDevice() {
            let dv = _.find(this.allDevice, d => d.bar_code == this.scan_val || d.description == this.scan_val || d.serial_number == this.scan_val || d.name == this.scan_val)
            if (!dv) {
                this.$message.warning(`未找到该设备`)
                return
            }
            // 当前设备是否被这台手术绑定使用中
            let usingdevice = _.find(this.usedDevice, d => d.dic_device_id == dv.id)
            if (usingdevice) {
                let using = _.find(usingdevice.use_device_details, d => d.begin_time != null && d.end_time == null)
                if (using) {
                    // 正在使用中，扫码解绑
                    this.activeDevice = dv
                    this.$set(this.activeDevice, `detail_id`, using.id)
                    this.$set(this.activeDevice, `begin_time`, this.$moment(using.begin_time).format(`yyyy-MM-DD HH:mm`))
                    this.$set(this.activeDevice, `end_time`, this.$moment().format(`yyyy-MM-DD HH:mm`))
                    this.$set(this.activeDevice, `showType`, `unbind`)
                    this.$set(this.activeDevice, `use_time`, this.difference(this.activeDevice.begin_time, this.activeDevice.end_time))
                } else {
                    this.activeDevice = dv
                    this.$set(this.activeDevice, `begin_time`, this.$moment().format(`yyyy-MM-DD HH:mm`))
                    this.$set(this.activeDevice, `showType`, `bind`)
                }
            } else {
                this.activeDevice = dv
                this.$set(this.activeDevice, `begin_time`, this.$moment().format(`yyyy-MM-DD HH:mm`))
                this.$set(this.activeDevice, `showType`, `bind`)
            }
            this.activeDevicePopupVisible = true
        },
        difference(beginTime, endTime) {
            let minutesDiff = 0
            if (beginTime != null && endTime != null) {
                if (beginTime <= endTime) {
                    let dateBegin = this.$moment(beginTime || ``)
                    let dateEnd = this.$moment(endTime || ``)
                    minutesDiff = dateEnd.diff(dateBegin, `minutes`)
                }
            }
            return minutesDiff
        },
        changeUseTime(beginTime, endTime) {
            this.$set(this.activeDevice, `use_time`, this.difference(beginTime, endTime))
        },
        remove(dv) {
            MessageBox.confirm(`此操作将永久删除该记录, 是否继续?`).then(action => {
                let req = this.myaxios.delete(`/api/Nursing/UseDevice/Delete/${dv.id}`)
                req.then(() => {
                    this.$message.success(`删除成功`)
                    this.loadDevices()
                })
            }).catch((action) => {

            })
        },
        useDevice(d) {
            let req = this.myaxios.post(`/api/Nursing/UseDevice/Post?ischeck=false`, {
                biz_surgery_info_id: this.surgeryId,
                dic_device_id: d.id
            })
            req.then((data) => {
                this.saveuseDeviceDetail(data.id).then(() => {
                    this.loadDevices()
                    this.activeDevicePopupVisible = false
                    this.$refs[`scan_device`].scan_val = ``
                })
            }).catch(e => {
                console.log(e)
            })
        },
        saveuseDeviceDetail(bizUseDeviceId) {
            return new Promise((resolve, reject) => {
                if (bizUseDeviceId == null) {
                    this.$message.error(`设备不能为空`)
                    return
                }
                if (this.activeDevice.begin_time == null) {
                    this.$message.error(`开始时间不能为空`)
                    return
                }

                let objs = {
                    id: this.activeDevice.detail_id,
                    biz_use_device_id: bizUseDeviceId,
                    use_time: this.activeDevice.use_time || 0,
                    begin_time: this.activeDevice.begin_time,
                    end_time: this.activeDevice.end_time,
                    dic_worker_id: this.currentUser && this.currentUser.dic_worker_id
                }
                console.log(objs)
                let req = this.myaxios.put(`/api/Nursing/UseDevice/PostOneUseDeviceDetail?biz_use_device_id=${bizUseDeviceId}`, objs)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        editDeviceDetail(detail, device) {
            this.activeDevice = device
            this.$set(this.activeDevice, `detail_id`, detail.id)
            this.$set(this.activeDevice, `begin_time`, this.$moment(detail.begin_time).format(`yyyy-MM-DD HH:mm`))
            this.$set(this.activeDevice, `end_time`, this.$moment(detail.end_time).format(`yyyy-MM-DD HH:mm`))
            this.$set(this.activeDevice, `use_time`, this.difference(detail.begin_time, detail.end_time))
            this.$set(this.activeDevice, `showType`, `edit`)
            this.activeDevicePopupVisible = true
        },
        deleteUserDevice(id) {
            MessageBox.confirm(`此操作将永久删除该记录, 是否继续?`).then(action => {
                let req = this.myaxios.delete(`/api/Nursing/UseDevice/DeleteUseDeviceDetail/${id}`)
                req.then(() => {
                    this.$message.success(`删除成功`)
                    this.loadDevices()
                })
            }).catch((action) => {

            })
        }
    },
    watch: {
        visible: function(newUrl, oldUrl) {
            if (this.visible) {
                alert(this.surgeryId)
                this.loadDevices()
            }
        },
        activeDevicePopupVisible: function(newVlaue, oldValue) {
            if (newVlaue == false) {
                this.activeDevice = {}
                this.scan_val = ``
                this.$refs[`scan_device`].scan_val = ``
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import './mobile_common.css';
.page {
    background-color: rgba(242, 242, 246, 1);
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 21px;
}
    .box_1 {
        background-color: rgba(241, 244, 246, 1);
        position: relative;
        height: 100%;
        margin: 0px auto;
        min-width: 334px;
        width: 100%;
    }

    .section_1 {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        justify-content: flex-center;
        padding: 0.2rem 0.1rem 0.1rem 0.2rem;
    }

    .icon_1 {
        width: 0.64rem;
        height: 0.64rem;
        margin: 0.16rem 0 0.16rem 0;
    }

    .text_1 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.587rem;
        margin: 0.187rem 0 0 0.107rem;
    }

    .input_1 {
        background-color: rgba(241, 244, 246, 1);
        border-radius: 20px;
        margin-left: 0.267rem;
        width: 60%;
        height: 0.85rem;
        padding: 0.05rem 0.187rem 0.2rem 0.22rem;
    }

    .el-input /deep/ .el-input__inner {
        height: 0.75rem;
        line-height: 0.75rem;
        background-color: #f1f4f6;
        border: none;
        font-size: 0.4rem;
        padding: 0px 4px 0px 15px;
    }

    .block_3 {
        margin: 0.054rem 0 0.027rem 0.4rem;
    }

    .icon_2 {
        width: 0.534rem;
        height: 0.534rem;
        margin: 0.027rem 0 0.027rem 0;
    }

    .text_2 {
        overflow-wrap: break-word;
        color: rgba(51, 51, 51, 1);
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.587rem;
        margin-left: 0.16rem;
    }

    .text_3 {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 0.3rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 13px;
        margin-left: -0.125rem;
    }

    .thumbnail_1 {
        width: 0.027rem;
        height: 0.534rem;
        margin: 0.027rem 0 0.027rem 0;
    }

    .section_2 {
        // padding-bottom: 0.827rem;
        flex: 1;
    }

    ::-webkit-scrollbar {
        height: 6px !important;
    }

    .tabs_1 {
        background-color: rgba(255, 255, 255, 1);
        padding: 0px 10px;
    }

    .text-wrapper_1 {
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .text {
        overflow-wrap: break-word;
        font-size: 0.426rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: right;
        white-space: nowrap;
        line-height: 0.5rem;
        padding: 10px 0 !important;
    }

    .text-wrapper_1 /deep/ .mint-tab-item {
        flex: 0;
    }

    .text-wrapper_1 /deep/ .is-selected {
        border-bottom: none;
        color: rgb(0, 150, 136);
    }

    .text /deep/ .mint-tab-item-label {
        font-size: inherit;
    }

    .group_1 {
        margin: 0.187rem 5.014rem 0 0;
    }

    .box_2 {
        background-color: rgba(0, 150, 136, 1);
        width: 1.707rem;
        height: 0.054rem;
    }

    .text-wrapper_base {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        padding: 0.427rem 0.427rem 0.427rem 0.427rem;
    }

    .text-wrapper_2 {
        margin-top: 0.267rem;
    }

    .text_base {
        overflow-wrap: break-word;
        font-size: 0.426rem;
        font-family: PingFangSC-Regular;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 0.427rem;

        .text_base_label {
            color: rgba(153, 153, 153, 1);
        }

        .text_base_value {
            color: rgba(51, 51, 51, 1);
        }
    }

    .box_4 {
        background-color: rgba(255, 255, 255, 1);
        padding: 0.64rem 2.8rem 9.12rem 2.854rem;
    }

    .image_2 {
        width: 3.947rem;
        height: 3.307rem;
    }

    .text-group_1 {
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 0.373rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 0.534rem;
        margin: 0 1.254rem 0 1.2rem;
    }

    .section_3 {
        background-color: rgba(255, 255, 255, 1);
        position: fixed;
        bottom: 30px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
        align-items: center;
    }

    .button_1 {
        background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
        border-radius: 4px;
        padding: 0.24rem 3.92rem 0.24rem 3.92rem;
        width: 100%;
    }

    .text_25 {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 0.59rem;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        width: 100%;
        white-space: nowrap;
        line-height: 0.587rem;
    }

    .timelines {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        margin-top: 0.267rem;
        padding: 0.32rem 0.32rem 0.587rem 0.427rem;

        .image-text_1 {
            width: 2.8rem;
            margin-right: 1.894rem;
        }

        .icon_3 {
            width: 0.587rem;
            height: 0.587rem;
        }

        .displayorder {
            background-color: rgba(0, 150, 136, 1);
            border-radius: 50%;
            // padding: 0 0.187rem 0 0.16rem;
            line-height: 0.256rem;
            height: 0.62rem;
            width: 0.62rem;

            .order_num {
                overflow-wrap: break-word;
                color: rgba(255, 255, 255, 1);
                font-size: 0.373rem;
                font-family: PingFangSC-Regular;
                font-weight: 500;
                text-align: right;
                white-space: nowrap;
                line-height: 0.587rem;
            }
        }

        .button_confirm {
            background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
            border-radius: 5px;
            color: #ffffff;
            font-size: 0.5rem;
            padding: 0.1rem;
            margin: 2px 0px;
            min-width: 108px;
        }

        .text-group_1 {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 0.4rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.587rem;
            margin: 0 1.254rem 0 0.3rem;
        }

        .box_3 {
            width: 4.427rem;
            margin-left: 0.267rem;
        }

        .group_6 {
            background-color: rgba(0, 150, 136, 1);
            width: 0.027rem;
            height: 0.64rem;
            margin-top: 0.214rem;
        }

        .text_5 {
            overflow-wrap: break-word;
            color: rgba(153, 153, 153, 1);
            font-size: 0.32rem;
            font-family: PingFangSC-Regular;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 0.534rem;
            padding-left: 0.534rem;
        }

        .text_6 {
            overflow-wrap: break-word;
            font-size: 0.5rem;
            color: rgba(102, 102, 102, 1);
            /* color: rgba(102, 102, 102, 1);
        font-size: 0.4rem;
        font-family: PingFangSC-Regular;
        font-weight: NaN;
        text-align: right;
        white-space: nowrap;
        line-height: 0.56rem;
        margin-top: 0.347rem; */
        }
    }

    .box_7 {
        background-color: rgba(0, 0, 0, 0.55);
        width: 100%;
        // height: 15.067rem;
        height: 100%;

        .group_11 {
            background-color: rgba(255, 255, 255, 1);
            border-radius: 12px 12px 0px 0px;
            padding-top: 0.427rem;
        }

        .text_confirm {
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 0.9);
            font-size: 0.48rem;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            text-align: right;
            white-space: nowrap;
            line-height: 0.694rem;
            align-self: center;
        }

        .text-wrapper_confirm {
            background-color: rgba(255, 255, 255, 1);
            width: 9.6rem;
            // margin-top: 0.4rem;
            padding: 0.427rem 0.2rem 0.427rem 0.25rem;
        }

        .text_confirm_detail {
            overflow-wrap: break-word;
            font-size: 0.426rem;
            font-family: PingFangSC-Regular;
            font-weight: NaN;
            text-align: left;
            white-space: nowrap;
            line-height: 0.427rem;
        }

        .confirm_box_button {
            background-color: rgba(255, 255, 255, 1);
            width: 100%;
            margin-top: 0.027rem;
            padding: 0.24rem 0.427rem 0.24rem 0.427rem;
        }

        .button_2 {
            background-image: linear-gradient(179deg, rgba(14, 209, 164, 1) 0, rgba(0, 150, 136, 1) 100%);
            border-radius: 4px;
            padding: 0.24rem 1.627rem 0.24rem 1.627rem;
        }

        .text_31 {
            overflow-wrap: break-word;
            color: rgba(255, 255, 255, 1);
            font-size: 0.426rem;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            text-align: right;
            white-space: nowrap;
            line-height: 0.587rem;
        }
    }

    /deep/.el-dialog__body {
        font-size: 0.5rem;
    }

    .deviceDilog /deep/.el-dialog__title {
        font-size: 0.5rem;
    }

    .deviceDilog /deep/ .el-button {
        font-size: 0.5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/DeviceBind.vue